import React, { useEffect, useMemo, useState } from 'react';
import { Tabs } from 'antd';
import OrderInfo from './components/OrderInfo';
import MenuList from './components/MenuList';
import i18n from '../../i18n';
import './style.css';
import TotalBar from './components/TotalBar';
import BottomBar from './components/BottomBar';
import FixedBottom from '../components/FixedBottom';
import StickyHeader from '../components/StickyHeader';
import { useMenu } from '../hooks/useMenu';
import { MenuItem } from '~/types/Menu';

const Menu = () => {
  const menu = useMenu();

  const tabItems = useMemo(() => {
    const allItems = menu.reduce((acc, cur) => {
      acc.push(...cur.items);
      return acc;
    }, [] as MenuItem[]);
    return [
      {
        label: i18n.t('menu_category_all'),
        key: 'all',
        children: <MenuList items={allItems} />,
      },
      ...menu.map((item) => {
        return {
          label: item.name,
          key: item.id,
          children: <MenuList items={item.items} />,
        };
      }),
    ];
  }, [menu]);

  return (
    <div className="menu-wrapper">
      <StickyHeader>
        <OrderInfo />
      </StickyHeader>
      <div className="menu-list-container">
        <Tabs defaultActiveKey="all" items={tabItems} />
      </div>
      <FixedBottom>
        <TotalBar />
        <BottomBar />
      </FixedBottom>
    </div>
  );
};

export default Menu;
